var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 229,
    viewBox: "0 0 263 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.914,
    y: 102.066,
    width: 53,
    height: 72,
    rx: 6,
    transform: "rotate(16.6268 201.914 102.066)",
    fill: "#03FF99"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.309,
    y: 125.969,
    width: 59.5957,
    height: 72,
    rx: 6,
    transform: "rotate(-8.46711 169.309 125.969)",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.309,
    y: 125.969,
    width: 59.5957,
    height: 72,
    rx: 6,
    transform: "rotate(-8.46711 169.309 125.969)",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.877,
    y: 126.39,
    width: 58.5957,
    height: 71,
    rx: 5.5,
    transform: "rotate(-8.46711 169.877 126.39)",
    stroke: "url(#paint0_linear_0_1)",
    strokeOpacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 182.25,
    y: 138.195,
    width: 14,
    height: 5,
    rx: 2.5,
    transform: "rotate(-8.46711 182.25 138.195)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.723,
    y: 148.086,
    width: 37.9129,
    height: 5,
    rx: 2.5,
    transform: "rotate(-8.46711 183.723 148.086)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.195,
    y: 157.977,
    width: 37.9129,
    height: 5,
    rx: 2.5,
    transform: "rotate(-8.46711 185.195 157.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.668,
    y: 167.867,
    width: 37.9129,
    height: 5,
    rx: 2.5,
    transform: "rotate(-8.46711 186.668 167.867)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.141,
    y: 177.758,
    width: 37.9129,
    height: 5,
    rx: 2.5,
    transform: "rotate(-8.46711 188.141 177.758)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 178.306,
    cy: 51.6824,
    r: 26.1122,
    transform: "rotate(1.10743 178.306 51.6824)",
    fill: "#03FF99"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.8691,
    y: 32.5352,
    width: 76.5573,
    height: 103.755,
    rx: 6.044,
    transform: "rotate(-19.9778 84.8691 32.5352)",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.8691,
    y: 32.5352,
    width: 76.5573,
    height: 103.755,
    rx: 6.044,
    transform: "rotate(-19.9778 84.8691 32.5352)",
    fill: "url(#paint1_linear_0_1)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5146,
    y: 32.8364,
    width: 75.55,
    height: 102.748,
    rx: 5.54033,
    transform: "rotate(-19.9778 85.5146 32.8364)",
    stroke: "url(#paint2_linear_0_1)",
    strokeWidth: 1.00733
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.042,
    cy: 156.542,
    r: 37.0078,
    transform: "rotate(9.3088 110.042 156.542)",
    fill: "#03FF99"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.1914,
    y: 74.9141,
    width: 87.8935,
    height: 119.119,
    rx: 6.93896,
    transform: "rotate(18.7001 48.1914 74.9141)",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.1914,
    y: 74.9141,
    width: 87.8935,
    height: 119.119,
    rx: 6.93896,
    transform: "rotate(18.7001 48.1914 74.9141)",
    fill: "url(#paint3_linear_0_1)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5537,
    y: 75.6472,
    width: 86.737,
    height: 117.962,
    rx: 6.36071,
    transform: "rotate(18.7001 48.5537 75.6472)",
    stroke: "url(#paint4_linear_0_1)",
    strokeWidth: 1.15649
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.4121,
    y: 137.648,
    width: 7.38622,
    height: 36.0078,
    rx: 3.69311,
    transform: "rotate(64.2909 90.4121 137.648)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.8281,
    y: 156.715,
    width: 7.38622,
    height: 21.2354,
    rx: 3.69311,
    transform: "rotate(154.291 67.8281 156.715)",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.902,
    y: 53.3047,
    width: 5.53507,
    height: 26.9835,
    rx: 2.76753,
    transform: "rotate(25.4916 146.902 53.3047)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.666,
    y: 75.0469,
    width: 5.53507,
    height: 15.9133,
    rx: 2.76753,
    transform: "rotate(115.492 142.666 75.0469)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 160.125,
    y: 95.856,
    width: 101.109,
    height: 112.836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.32479
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_0_1",
    x: 150.125,
    y: 98.0117,
    width: 107.914,
    height: 118.355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 76.495,
    y: 0.346631,
    width: 137.996,
    height: 140.416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.34183
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.03666
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_0_1",
    x: 66.4217,
    y: -12.0685,
    width: 144.293,
    height: 160.563,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.0733
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_0_1",
    x: 0.292492,
    y: 67.8932,
    width: 158.327,
    height: 160.427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.6886
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.78246
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_0_1",
    x: -11.2724,
    y: 53.6397,
    width: 163.99,
    height: 183.557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.5649
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_0_1",
    x: 41.6323,
    y: 129.94,
    width: 62.3135,
    height: 43.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.6886
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.78246
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_0_1",
    x: 115.275,
    y: 45.3502,
    width: 47.2685,
    height: 48.0244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.6886
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.78246
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 228.904,
    y1: 125.969,
    x2: 188.451,
    y2: 199.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 187.113,
    y1: -24.8828,
    x2: 108.541,
    y2: 153.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 2.26785,
    y1: 0.804175,
    x2: 143.294,
    y2: 136.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 165.575,
    y1: 8.99397,
    x2: 75.369,
    y2: 213.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: -46.641,
    y1: 38.4845,
    x2: 115.268,
    y2: 194.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestCard);
export default __webpack_public_path__ + "static/media/test_card.1b7999887fd7a93e8fd92567b4a4170e.svg";
export { ForwardRef as ReactComponent };